module.exports = __webpack_public_path__ + "img/koala_2.847bc18c.jpg";